/*
  AFB IS HERE LP 用スクリプト。
  モバイルのスティッキーCTA（.afb-sticky-cta）が、テーマ共通フッター
  （Exhibit の footer-group / 既存ファイルは改変できない）に重なって
  リンクを覆わないよう、フッターが視界に入ったらCTAを隠す。
*/
(() => {
  const cta = document.querySelector('.afb-sticky-cta');
  if (!cta) return;
  const footer = document.querySelector('[id^="shopify-section"][id*="footer"], footer');
  if (!footer || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      cta.classList.toggle('afb-sticky-cta--hidden', entry.isIntersecting);
    }
  });
  observer.observe(footer);
})();
